import script from "./Terrain.vue?vue&type=script&setup=true&lang=js"
export * from "./Terrain.vue?vue&type=script&setup=true&lang=js"

import "./Terrain.vue?vue&type=style&index=0&id=bed118ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bed118ea"]])

export default __exports__